import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./CustomSwiper.css";

const CustomSwiper = () => {
  const [slides, setSlides] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/slides/get`);
        setSlides(response.data.slides || []);
      } catch (err) {
        console.log("Fetch error:", err.response || err);
        setError("Failed to load slides. Please try again.");
      }
    };
    fetchSlides();
  }, []);

  useEffect(() => {
    if (slides.length > 0 && window.Swiper) {
      new window.Swiper(".swiper", {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
      });
    }
  }, [slides]);

  if (error) {
    return <div className="swiper-error" style={{ textAlign: "center", padding: "2rem", color: "#dc2626" }}>{error}</div>;
  }

  if (slides.length === 0 && !error) {
    return null;
  }

  return (
    <div className="swiper-container swiper">
      <div className="swiper-wrapper">
        {slides.map((slide) => (
          <div className="swiper-slide" key={slide._id}>
            {slide.link.startsWith("http") ? (
              <a href={slide.link} target="_blank" rel="noopener noreferrer">
                <img src={slide.image} alt={slide.alt} style={{ width: "100%", height: "auto" }} />
              </a>
            ) : (
              <Link to={slide.link}>
                <img src={slide.image} alt={slide.alt} style={{ width: "100%", height: "auto" }} />
              </Link>
            )}
          </div>
        ))}
      </div>
      <div className="swiper-pagination"></div>
    </div>
  );
};

export default CustomSwiper;